export default __webpack_public_path__ + "static/writing-gem-d31762b49f35169116393bb950eded65.webp";